// 配置管理工具

/**
 * 根据当前页面主机推断后端API基础地址
 * 在生产环境中，如果使用nginx反向代理，应该使用相对路径（空字符串）
 * @returns {string} API基础URL
 */
export const inferApiBaseUrl = () => {
  try {
    // 如果已经设置了环境变量，直接使用
    if (process.env.REACT_APP_API_BASE_URL !== undefined) {
      return process.env.REACT_APP_API_BASE_URL;
    }
    
    // 在生产环境中，如果使用nginx反向代理，使用相对路径
    // 这样可以通过同一个域名访问前端和后端API
    if (process.env.NODE_ENV === 'production') {
      return '';
    }
    
    // 开发环境：使用当前主机和指定端口
    const protocol = typeof window !== 'undefined' ? window.location.protocol : 'http:';
    const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
    const port = process.env.REACT_APP_API_PORT || '8000';
    return `${protocol}//${hostname}:${port}`;
  } catch (_) {
    // 出错时返回空字符串，使用相对路径通过Nginx代理
    return '';
  }
};

/**
 * API基础URL，从环境变量读取
 * 在开发环境中使用相对路径，通过setupProxy.js代理转发
 * 在生产环境中，如果使用nginx反向代理，也使用相对路径
 */
export const API_BASE_URL = inferApiBaseUrl();

/**
 * API版本前缀
 */
export const API_PREFIX = '/api/v1';
